export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

 export const loadingTemplate = `
  <div class="labs-loading-container">
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </div>
`;

export const isTouchDevice = () => {
  if (window.matchMedia("(hover: none)").matches) {
    return true;
  }
  return false;
};

export function getRegionContactMail(region) {
  switch(region) {
    case 'EUMEA':
      return 'medinfoeu@bmrn.com';
    case 'LATAM':
      return 'medinfola@bmrn.com';
    case 'APAC':
      return 'medinfoasia@bmrn.com';
    case 'NORAM':
    default:
      return 'medinfo@bmrn.com';
  }
};

export const adaptGeneralInfoToRegion = function(regionCode) {
  const labInfoContactElements = document.querySelectorAll('.lab-info__contact');
  labInfoContactElements.forEach(element => {
    const phoneOrMailSection = document.querySelector('.lab-info__contact-section--phone-or-mail');
    element.removeChild(phoneOrMailSection);
  });

  // const regionElements = document.querySelectorAll(`.other-countries-info__region-container:not(.${regionCode})`);
  // regionElements.forEach(element => {
  //   element.parentNode.removeChild(element);
  // });
}

export const jQueryParseMailLink = function() {
  var html = jQuery(this).html();
  var emailPattern = /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/g;  

  var matched_str = $(this).html().match(emailPattern);
  if(matched_str){
    var text = $(this).html();
    jQuery.each(matched_str, function(index, value){
        text = text.replace(value,"<a class='lab-info__contact-value--link' href='mailto:"+value+"'>"+value+"</a>");
    });
    jQuery(this).html(text);
  return $(this)
  }    
};

export const isMailLink = function(link) {
  var emailPattern = /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/g;  
  return link.match(emailPattern);
};